import { createSlice } from "@reduxjs/toolkit";
const calcSideBarHeight = () => {
  let appHead = document.getElementById("tdAppHeader");
  if (appHead) {
    let navH = document.getElementById("tdAppHeader").clientHeight + 2;
    return window.innerHeight - navH;
    console.log(window.innerHeight - navH);
  } else {
    return window.innerHeight - 57;
  }
};
const initialState = {
  value: {
    fullHeight: window.innerHeight,
    fullWidth: window.innerWidth,
    sideBarHeight: calcSideBarHeight()
  }
};
const screenSizeSlice = createSlice({
  name: "screenSize",
  initialState,
  reducers: {
    recalc: (state) => {
      state.value = {
        fullHeight: window.innerHeight,
        fullWidth: window.innerWidth,
        sideBarHeight: calcSideBarHeight()
      };
    }
  }
});
export const { recalc } = screenSizeSlice.actions;
export default screenSizeSlice.reducer;
